/* global WebView, FormController */
/**
 * This interceptor compute breadcrumbs to display on main page
 */
 module.exports = [
    {
        type: "navigation", //called on navigation
        interceptor: function (app, context, next){
            if(!app.context.isV2){ return next() ; }
            app.context.controllers.mainController.view.ensureDisplayed(function(){
                // console.log("bread 1");

                var breadcrumbs = [] ;
                var link = "" ;
                var routes = app._getRoutes(app.currentRoute) ;
                routes.forEach(function(route){
                    if(route.route && !route.isPopup && route.def && route.def && route.def.controller && route.def.controller.viewOptions){
                        var title = route.def.controller.viewOptions.title ;
                        if (!title) {
                            let titleTrKey = "fields.table." + route.def.controller.table ;
                            if(route.def.controller.constructor === FormController){
                                titleTrKey = "fields.table." + route.def.controller.table+"_sing" ;
                            }
                            let trValue =  WebView.tr(titleTrKey) ;
                            if(titleTrKey !== trValue){
                                title = trValue ;
                            } else{
                                title = WebView.tr("fields.table." + route.def.controller.table);
                            }
                        }
                        link += "#!"+route.route;
                        if(route.data){
                            if(typeof(route.data) === "object"){
                                link += "$"+encodeURIComponent(JSON.stringify(route.data)) ;
                            }else{
                                link += "$"+route.data ;
                            }
                        }
                        var crumbs = {
                            link: link,
                            title: title,
                        } ;
                        if(route.def.controller.viewOptions.titleExpr){
                            crumbs.title = '<i class="fas fa-circle-notch fa-spin"></i>' ;
                            // console.log("bread title 1", crumbs.title);
                            if(route.def.controller.data){
                                crumbs.title = WebView.compileTemplate(route.def.controller.viewOptions.titleExpr, route.def.controller.data) ;
                                if(crumbs.title === "undefined"){
                                    crumbs.title = '<i class="fas fa-circle-notch fa-spin"></i>' ;
                                }
                                // console.log("bread title 2", crumbs.title);
                            }
                            var onRender = function(){
                                // console.log("bread 3", route.def.controller.data);
                                crumbs.title = WebView.compileTemplate(route.def.controller.viewOptions.titleExpr, route.def.controller.data) ;
                                if(crumbs.title === "undefined"){
                                    crumbs.title = '<i class="fas fa-circle-notch fa-spin"></i>' ;
                                }
                                app.context.controllers.mainController.view.render() ;
                                // console.log("bread title 3", crumbs.title);
                            };
                            route.def.controller.view.once("render",onRender);
                            route.def.controller.on("updateTitle",onRender);
                        }
                        breadcrumbs.push(crumbs);
                    }
                });
                // console.log("bread 4");
                if(breadcrumbs.length>0){
                    app.context.controllers.mainController.data.currentCrumb = breadcrumbs[breadcrumbs.length-1]||{title: '<i class="fas fa-circle-notch fa-spin"></i>'} ;
                    breadcrumbs.splice(breadcrumbs.length-1, 1);
                }else{
                    app.context.controllers.mainController.data.currentCrumb = {title: '<i class="fas fa-circle-notch fa-spin"></i>'};
                }

                app.context.controllers.mainController.data.breadcrumbs = breadcrumbs ;
                app.context.controllers.mainController.view.render() ;
                // console.log("bread 5");
            }) ;

            next() ;
        }
    }
]; 